import React, { useState } from "react";
import styled from "styled-components";
import { signOut } from "../../auth/services/authService";

const Button = styled.button`
  background: none;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  padding: 7px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #444;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover:not(:disabled) {
    background: #f5f5f5;
    border-color: #b0b0b0;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const SignOutButton: React.FC = () => {
  const [isSigningOut, setIsSigningOut] = useState<boolean>(false);

  async function handleSignOut(): Promise<void> {
    setIsSigningOut(true);
    const result = await signOut();
    if (result.error) {
      console.error("Sign-out error:", result.error);
      setIsSigningOut(false);
    }
  }

  return (
    <Button type="button" onClick={handleSignOut} disabled={isSigningOut}>
      {isSigningOut ? "Signing out..." : "Sign Out"}
    </Button>
  );
};

export default SignOutButton;
